import React, { useState, useEffect, useRef } from "react";
import Header from "../components/header/Header";
import ExposureHeader from "../components/ExposureHeader/ExposureHeader";
import { Outlet } from "react-router-dom";
import Footer from "../components/Footer/Footer";
import ScrollGames from "../components/ScrollGames/ScrollGames";
import SideMenu from "../components/SideMenu/SideMenu";
import "../App.css"; // Ensure your styles are imported
import OpenBets from "../components/OpenBets/OpenBets";
import DepositWithdraw from "../components/DepositWithdraw";
import Helper from "../helper";
import { useLocation } from "react-router-dom";

function MainLayout() {

  const userInfo = Helper();
  const [showMenu, setShowMenu] = useState(false); // <-- Add this
  // Responsive isMobile state
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 991);
  const [eventType, setEventType] = useState(undefined); // or your default
  const location = useLocation();
  
    // Handler to toggle menu
  const handleToggleMenu = () => setShowMenu((prev) => !prev);

  

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 991);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Header
        showMenu={showMenu}
        handleToggleMenu={handleToggleMenu}
        isMobile={isMobile}
      />
      <div style={{ position: "fixed", zIndex: "2", width: "100%" }}>
        <ScrollGames 
          setEventType={setEventType} 
          eventType={eventType} 
          isMobile={isMobile}
        />
      </div>
      <div className="main-content-wrapper">
        {isMobile ? (
        <>
          <div style={{ width: "100%" }}>
            <Outlet />
          </div>
          {/* Overlay */}
          <div
            className="sidemenu-overlay"
            style={{ display: showMenu ? "block" : "none" }}
            onClick={() => setShowMenu(false)}
          />
          {/* SideMenu Drawer */}
          <div
            className={`sidemenu-mobile${showMenu ? " open" : ""}`}
            onClick={e => e.stopPropagation()}
          >
            <SideMenu handleToggleMenu={handleToggleMenu} isMobile={isMobile} />
          </div>
        </>
        ) : (
          <div className="mainscreen-container">
            <div>
              <SideMenu />
            </div>
            <div style={{ width: location.pathname === "/openbets" ? "100%" : "55%" }}>
              <Outlet />
            </div>
            {location.pathname !== "/openbets" && (
              <div style={{ width: "25%" }}>
                <OpenBets />
              </div>
            )}
          </div>
        )}
      </div>
      {/* <ExposureHeader /> */}
      {/* <main className="flex-1 overflow-y-auto pb-20">
        <Outlet />
      </main> */}
      {/* <Footer /> */}
    </div>
  );
}

export default MainLayout;
